module.exports = __webpack_public_path__ + "img/logo.5da9d4a8.png";